import { Button, Modal } from '@classgo/ui';

/**
 * A yes/no question before something destructive; the confirming button is the danger one.
 */
export const ConfirmDialog = ({
  open,
  title,
  body,
  confirmLabel,
  cancelLabel,
  busy = false,
  error,
  onConfirm,
  onClose,
}: {
  open: boolean;
  title: string;
  body: string;
  confirmLabel: string;
  cancelLabel: string;
  busy?: boolean;
  error?: string | null;
  onConfirm: () => void;
  onClose: () => void;
}) => (
  <Modal
    open={open}
    onClose={onClose}
    title={title}
    size="sm"
    actions={
      <>
        <Button variant="secondary" onClick={onClose}>
          {cancelLabel}
        </Button>
        <Button variant="danger" loading={busy} onClick={onConfirm}>
          {confirmLabel}
        </Button>
      </>
    }
  >
    <p className="text-sm text-gray-600">{body}</p>
    {error ? (
      <p
        role="alert"
        className="mt-3 rounded-control bg-danger-100 px-3 py-2 text-sm text-danger-700"
      >
        {error}
      </p>
    ) : null}
  </Modal>
);
